import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import {
  AppBar,
  CssBaseline,
  Toolbar,
  List,
  Divider,
  ListItem,
  ListItemText,
  Box,
} from "@material-ui/core";
import shortLogo from "../../../assets/shortLogo.svg";
import { withRouter } from "react-router-dom";
import Dashboard from "../../Dashboard";
import { useWeb3React } from "@web3-react/core";
import {
  campaignCounts,
  registerKOL,
} from "../../../contract/functions/functions";
import { useSelector } from "react-redux";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    // fontSize:"2rem"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  subList: {
    marginLeft: "20px",
  },
  text: {
    fontSize: "1.3rem",
    color: "#7886A1",
  },
}));

function DashboardLayout(props) {
  const classes = useStyles();
  const { history } = props;

  const [toggle, setToggle] = useState(false);

  const web3Context = useWeb3React();

  const networkSet = useSelector((state) => state.web3.networkSet);
  const isUser = useSelector((state) => state.ui.isUser);

  console.log("isUser networkSet =< ", networkSet, isUser);
  // useEffect(() => {
  //   if (web3Context.account || networkSet) {
  //     // campaignCounts(web3Context.account);
  //     // registerKOL(web3Context.account);
  //   }
  // }, [web3Context, networkSet]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <img src={shortLogo} alt="protokol" />
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        {/* <Divider /> */}
        <div className={classes.drawerContainer}>
          <Divider />
          <List>
            <ListItem
              button
              onClick={() => {
                history.push("/dashboard");
              }}
            >
              <ListItemText
                primary={"Dashboard"}
                disableTypography={true}
                className={classes.text}
              />
            </ListItem>

            {isUser.kol && (
              <ListItem
                button
                onClick={() => {
                  history.push("/search-token-pools");
                }}
              >
                <ListItemText
                  disableTypography={true}
                  className={classes.text}
                  primary={"Search Token Pools"}
                />
              </ListItem>
            )}
            {isUser.project && (
              <ListItem
                button
                onClick={() => {
                  history.push("/createtokenpool");
                }}
              >
                <ListItemText
                  disableTypography={true}
                  className={classes.text}
                  primary={"Create Token Pools"}
                />
              </ListItem>
            )}
            <ListItem
              button
              onClick={() => {
                {
                  {
                    isUser.project
                      ? history.push("/progresshub")
                      : setToggle(!toggle);
                  }
                }
              }}
            >
              <ListItemText
                disableTypography={true}
                className={classes.text}
                primary={"Progress Hub"}
              />
            </ListItem>
            {isUser.kol && toggle ? (
              <Box className={classes.subList}>
                <ListItem
                  button
                  onClick={() => {
                    history.push("/progresshuboverview");
                  }}
                >
                  <ListItemText
                    disableTypography={true}
                    className={classes.text}
                    primary={"Overview"}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push("/progresshubdetails");
                  }}
                >
                  <ListItemText
                    disableTypography={true}
                    className={classes.text}
                    primary={"Project Details"}
                  />
                </ListItem>
              </Box>
            ) : null}

            <ListItem
              button
              onClick={() => {
                history.push("/managefunds");
              }}
            >
              <ListItemText
                disableTypography={true}
                className={classes.text}
                primary={"Manage funds"}
              />
            </ListItem>
          </List>
          <Divider />
        </div>
      </Drawer>
      <main className={classes.content}>
        <Toolbar />
        {props.children}
      </main>
    </div>
  );
}

export default withRouter(DashboardLayout);
